import { FC, memo, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { encodeToBase64 } from '@medicusunion/front-utils';
import { Link } from 'react-router-dom';
import config from 'config';

import { tokenStorage, refreshTokenStorage } from 'utils/storage';
import UploadDicom from '../UploadDicom';
import { CreateItem } from 'components/shared';

const CreateDicom: FC = () => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const dicomLink = useMemo(() => {
    const token = encodeToBase64(tokenStorage.get());
    const refreshToken = encodeToBase64(refreshTokenStorage.get());

    return `${config.viewer_url}?t=${token}&r=${refreshToken}`;
  }, []);

  return (
    <>
      <CreateItem title={t('dicom.dicom_viewer')}>
        <Button
          ghost
          icon={<UploadOutlined />}
          size="large"
          type="primary"
          onClick={() => setIsModalVisible(true)}
        >
          {t('dicom.upload_and_share')}
        </Button>
        <Link to={dicomLink} target="_blank" rel="noreferrer">
          <Button size="large" type="primary" icon={<EyeOutlined />}>
            {t('dicom.view_dicom')}
          </Button>
        </Link>
      </CreateItem>
      {isModalVisible && (
        <UploadDicom onClose={() => setIsModalVisible(false)} />
      )}
    </>
  );
};

export default memo(CreateDicom);
